import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  private loginUrl = `${environment.apiUrl}/api/authentication/login`;
  private logoutUrl = `${environment.apiUrl}/api/authentication/logout`;
  private authStatusUrl = `${environment.apiUrl}/api/authentication/status`;
  private switchUserUrl = `${environment.apiUrl}/api/authentication/switch-user`;
  private switchBackUrl = `${environment.apiUrl}/api/authentication/switch-back`;

  login(credentials: { username: string; password: string }): Observable<any> {
    return this.http.post(this.loginUrl, credentials, {
      withCredentials: true,
    });
  }

  logout(): Observable<any> {
    return this.http.post(
      this.logoutUrl,
      {},
      {
        withCredentials: true,
      }
    );
  }

  checkAuthStatus(): Observable<any> {
    return this.http.get(this.authStatusUrl, { withCredentials: true });
  }

  switchUser(targetUserId: string): Observable<any> {
    return this.http.post(
      this.switchUserUrl,
      { targetUserId },
      {
        withCredentials: true,
      }
    );
  }

  switchBack(): Observable<any> {
    return this.http.post(
      this.switchBackUrl,
      {},
      {
        withCredentials: true,
      }
    );
  }
}
